/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseReviewsFragment, ReviewsFragment, FullReviewsFragment} from '@amblique/contentful/app/contentful/fragments/reviews';

/**
 * Get a single Reviews by ID (base - scalars only)
 */
export const getBaseReviewsById = gql`
  ${BaseReviewsFragment}

  query GetBaseReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    reviews(id: $id, locale: $locale, preview: $preview) {
      ...BaseReviewsFragment
    }
  }
`;

/**
 * Get a single Reviews by ID (standard - 1 level deep)
 */
export const getReviewsById = gql`
  ${ReviewsFragment}

  query GetReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    reviews(id: $id, locale: $locale, preview: $preview) {
      ...ReviewsFragment
    }
  }
`;

/**
 * Get a single Reviews by ID (full - 2 levels deep)
 */
export const getFullReviewsById = gql`
  ${FullReviewsFragment}

  query GetFullReviewsById($id: String!, $locale: String!, $preview: Boolean) {
    reviews(id: $id, locale: $locale, preview: $preview) {
      ...FullReviewsFragment
    }
  }
`;

/**
 * Get all Reviews entries with pagination (base - scalars only)
 */
export const getBaseReviewss = gql`
  ${BaseReviewsFragment}

  query GetBaseReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewsOrder]
    $where: ReviewsFilter
    $preview: Boolean
  ) {
    reviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseReviewsFragment
      }
    }
  }
`;

/**
 * Get all Reviews entries with pagination (standard - 1 level deep)
 */
export const getReviewss = gql`
  ${ReviewsFragment}

  query GetReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewsOrder]
    $where: ReviewsFilter
    $preview: Boolean
  ) {
    reviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ReviewsFragment
      }
    }
  }
`;

/**
 * Get all Reviews entries with pagination (full - 2 levels deep)
 */
export const getFullReviewss = gql`
  ${FullReviewsFragment}

  query GetFullReviewss(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ReviewsOrder]
    $where: ReviewsFilter
    $preview: Boolean
  ) {
    reviewsCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullReviewsFragment
      }
    }
  }
`;
